export const THEME =
  process.env.REACT_APP_STYLE === "shaw" ? "shaw" : "freedom";
